// Build447: restore QR before NFC so constraints use the imported geometry.
// Build437: editor file drop and named downloads; shared import/export contracts preserved.
// Build432: justified paragraphs, shared whitespace advances.
// Build431: persisted paragraph alignment for standard and additional straight text.
// Build424: editable attached arrow labels; NFC supplies defaults, not a visibility lock.
// Build416: groups in guarded V9/V10 files; old ungrouped versions remain unchanged.
// Build405: Italian editor localization; historical predecessor retained.
// Build404: shared DE/EN laser import notice and retained template restrictions.
// Build362: guarded single/two-sided curved-text files V7/V8.
// Build 20260911-342: rich text ranges.
(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle)) return;
  if (window.__smoofDesignFileV240) return;
  window.__smoofDesignFileV240 = true;
  window.__smoofDesignFileV238 = true;
  window.__smoofDesignFileV237 = true;
  window.__smoofDesignFileV236 = true;
  window.__smoofDesignFileV234 = true;
  window.__smoofDesignFileV232 = true;
  document.documentElement.dataset.smoofDesignFileRuntime = 'v2.47-20261009-447';
  window.__smoofDesignFileV231 = true;
  window.__smoofDesignFileV230 = true;
  window.__smoofDesignFileV229 = true;
  window.__smoofDesignFileV228 = true;
  window.__smoofDesignFileV227 = true;
  window.__smoofDesignFileV226 = true;

  const FORMAT = 'SMOOF_DESIGN';
  const VERSION = 16;
  const SUPPORTED_VERSIONS = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
  const PRODUCT_CONFIGURATION_SCHEMA = 'smoof-product-configuration-1.0';
  const MAX_FILE_BYTES = 50 * 1024 * 1024;
  const FONT_OPTION_ID = '052c068b-772b-4d04-af0d-56214e55cce3';
  const PRODUCT_OPTION_INDEXES = new Set(['1', '2', '3']);
  const PRODUCT_CONFIGURATION_PROPERTIES = new Set([
    'properties[_SMOOF Product Profile]',
    'properties[_SMOOF NFC]',
    'properties[_SMOOF Druckformat mm]',
    'properties[_SMOOF Materialart]',
    'properties[_SMOOF Material]',
    'properties[_SMOOF Holzart]',
    'properties[_SMOOF Druckverfahren]',
    'properties[_SMOOF Designflaechen]',
    'properties[_SMOOF Variant ID]',
    'properties[_SMOOF Variant Schema]',
    'properties[_SMOOF Gestaltungsart Schema]',
    'properties[_SMOOF Gestaltungsart]',
    'properties[_SMOOF Design Service]',
    'properties[_SMOOF Produktionsfreigabe]'
  ]);
  const IMAGE_DATA_URL = /^data:image\/(?:png|jpe?g|webp|gif|svg\+xml)(?:;[^,]*)?,/i;
  const root = document.documentElement;
  const t = (de, en) => window.SmoofI18n.copy(de, en);
  let picker = null;
  let statusTimer = 0;

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function showStatus(message, error = false, duration = 3200) {
    let status = document.querySelector('[data-smoof-design-file-status]');
    if (!status) {
      status = document.createElement('div');
      status.dataset.smoofDesignFileStatus = 'true';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }
    clearTimeout(statusTimer);
    status.textContent = message;
    status.dataset.error = String(error);
    status.dataset.visible = 'true';
    statusTimer = setTimeout(() => { status.dataset.visible = 'false'; }, duration);
  }

  function laserImportNotice(payload, applyProductConfiguration = false) {
    const profile = window.SmoofProductProfiles?.current;
    if (!profile?.editorPolicy?.forceMonochromeLaser) return '';
    let process = document.documentElement.dataset.smoofPrintProcess || window.SmoofProductVariant?.get?.()?.printProcess;
    const saved = payload?.productConfiguration?.printProcess;
    if (applyProductConfiguration && profile?.optionAxes?.process && profile.processValues?.includes(saved)) process = saved;
    return process === 'laser'
      ? t('Bei der Lasergravur werden die Farben Ihrer Vorlage in Schwarz umgewandelt.', 'For laser engraving, the colours in your design are converted to black.') : '';
  }
  function importStatus(message, restrictions = []) {
    const removed = restrictions.some(code => /(?:logo(?:-2)?-removed-laser-vector-required|extra-pictogram-removed-laser-vector-required)/.test(code));
    const parts = [message, laserImportNotice()];
    if (removed) parts.push(t('Nicht lasergeeignete Bilder oder Piktogramme wurden ausgelassen.', 'Images or pictograms unsuitable for laser engraving were omitted.'));
    showStatus(parts.filter(Boolean).join(' '), false, parts[1] || removed ? 8000 : 3200);
  }

  function nativeValue(control, value) {
    if (!control) return;
    if (control instanceof HTMLInputElement && control.type === 'file') {
      if (String(value ?? '') === '') control.value = '';
      return;
    }
    const prototype = control instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : control instanceof HTMLTextAreaElement
        ? HTMLTextAreaElement.prototype
        : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor?.set) descriptor.set.call(control, value);
    else control.value = value;
  }

  function nativeChecked(control, checked) {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
    if (descriptor?.set) descriptor.set.call(control, checked);
    else control.checked = checked;
  }

  function notifyControl(control) {
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function editableControls(container) {
    return Array.from(container.querySelectorAll('input, select, textarea'))
      .filter(control =>
        control.closest('[data-option-id]') === container &&
        !['file', 'button', 'submit', 'reset'].includes(control.type) &&
        control.dataset.smoofDesignFilePicker !== 'true'
      );
  }

  function isProductConfigurationOption(container) {
    return editableControls(container).some(control =>
      PRODUCT_OPTION_INDEXES.has(String(control.dataset.optionIndex || ''))
    );
  }

  function captureProductConfiguration() {
    return Array.from(PRODUCT_OPTION_INDEXES).map(index => {
      const controls = Array.from(document.querySelectorAll(
        `main input[type="radio"][data-option-index="${index}"]`
      ));
      const checked = controls.find(control => control.checked);
      return {
        index,
        value: checked?.value || '',
        dataKey: checked ? controlDataKey(checked) : '',
        ordinal: checked ? controls.indexOf(checked) : -1
      };
    });
  }

  function restoreProductConfiguration(configuration) {
    (Array.isArray(configuration) ? configuration : []).forEach(saved => {
      const controls = Array.from(document.querySelectorAll(
        `main input[type="radio"][data-option-index="${saved.index}"]`
      ));
      if (!controls.length || controls.some(control => control.checked && (
        control.value === saved.value ||
        (saved.dataKey && controlDataKey(control) === saved.dataKey) ||
        controls.indexOf(control) === saved.ordinal
      ))) return;
      const target = controls.find(control => saved.dataKey && controlDataKey(control) === saved.dataKey) ||
        controls.find(control => control.value === saved.value) ||
        controls[Number(saved.ordinal)] || null;
      if (target && !target.checked) target.click();
    });
  }

  function capturePortableProductConfiguration() {
    const profile = window.SmoofProductProfiles?.current || {};
    const axes = profile.optionAxes || {};
    const state = window.SmoofProductVariant?.get?.() || {};
    const configuration = { schema: PRODUCT_CONFIGURATION_SCHEMA };
    if (axes.nfc) configuration.nfcCode = state.nfcCode || 'without_nfc';
    if (axes.format && Number.isFinite(Number(state.diameterMm))) {
      configuration.diameterMm = Number(state.diameterMm);
    }
    if (axes.material) {
      configuration.materialKind = state.materialKind || profile.material?.kind || '';
      configuration.materialCode = state.materialCode || state.woodCode || '';
    }
    if (axes.process) configuration.printProcess = state.printProcess || '';
    return configuration;
  }

  function productConfigurationSignature(state) {
    return JSON.stringify({
      variantId: state?.variantId || '',
      nfcCode: state?.nfcCode || '',
      diameterMm: Number(state?.diameterMm) || null,
      materialCode: state?.materialCode || '',
      printProcess: state?.printProcess || ''
    });
  }

  function nextFrames() {
    return new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  }

  async function waitForProductConfiguration(timeoutMs = 4000) {
    const started = Date.now();
    let previous = '';
    let stableReads = 0;
    while (Date.now() - started < timeoutMs) {
      window.SmoofProductVariant?.refresh?.();
      await new Promise(resolve => setTimeout(resolve, 100));
      const signature = productConfigurationSignature(window.SmoofProductVariant?.get?.());
      if (signature && signature === previous && root.dataset.smoofVariantTransition !== 'true') {
        stableReads += 1;
        if (stableReads >= 2) return window.SmoofProductVariant?.get?.() || null;
      } else {
        previous = signature;
        stableReads = 0;
      }
    }
    return window.SmoofProductVariant?.get?.() || null;
  }

  function productAxisControls(index) {
    if (!index) return [];
    return Array.from(document.querySelectorAll(
      `main input[type="radio"][data-option-index="${index}"]`
    ));
  }

  function parseDiameter(value) {
    const match = String(value || '').match(/(\d+(?:[.,]\d+)?)/);
    const parsed = Number(match?.[1]?.replace(',', '.'));
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function controlAvailable(control) {
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return false;
    const label = control.closest('label');
    return label?.getAttribute('aria-disabled') !== 'true';
  }

  function productConfigurationRequests(configuration, profile) {
    const axes = profile.optionAxes || {};
    const requests = [];
    const has = key => Object.prototype.hasOwnProperty.call(configuration, key);
    if (has('nfcCode')) {
      requests.push({
        key: 'nfc',
        index: axes.nfc,
        supported: profile.supportsNfc === true && Boolean(axes.nfc),
        target: controls => controls[configuration.nfcCode === 'with_nfc' ? 1 : 0] || null
      });
    }
    if (has('diameterMm')) {
      requests.push({
        key: 'format',
        index: axes.format,
        supported: Boolean(axes.format),
        target: controls => controls.find(control => parseDiameter(control.value) === Number(configuration.diameterMm)) || null
      });
    }
    if (has('materialCode')) {
      const materialPosition = profile.material?.values?.indexOf(configuration.materialCode) ?? -1;
      requests.push({
        key: 'material',
        index: axes.material,
        supported: Boolean(axes.material) && profile.material?.kind === configuration.materialKind && materialPosition >= 0,
        target: controls => controls[materialPosition] || null
      });
    }
    if (has('printProcess')) {
      const processPosition = profile.processValues?.indexOf(configuration.printProcess) ?? -1;
      requests.push({
        key: 'process',
        index: axes.process,
        supported: Boolean(axes.process) && processPosition >= 0,
        target: controls => controls[processPosition] || null
      });
    }
    return requests.sort((left, right) => Number(left.index || 99) - Number(right.index || 99));
  }

  async function applyPortableProductConfiguration(configuration) {
    const profile = window.SmoofProductProfiles?.current || {};
    const result = {
      schema: PRODUCT_CONFIGURATION_SCHEMA,
      requested: cleanForJson(configuration),
      applied: [],
      ignored: [],
      actual: null
    };
    for (const request of productConfigurationRequests(configuration, profile)) {
      if (!request.supported) {
        result.ignored.push(`${request.key}-unsupported`);
        continue;
      }
      const controls = productAxisControls(request.index);
      const target = request.target(controls);
      if (!target) {
        result.ignored.push(`${request.key}-unavailable`);
        continue;
      }
      if (!controlAvailable(target)) {
        result.ignored.push(`${request.key}-disabled`);
        continue;
      }
      if (!target.checked) {
        target.click();
        await nextFrames();
        await waitForProductConfiguration(1800);
      }
      result.applied.push(request.key);
    }
    result.actual = cleanForJson(await waitForProductConfiguration());
    return result;
  }

  function controlDataKey(control) {
    return control.dataset.optionValueId ||
      control.dataset.valueId ||
      control.dataset.optionValue ||
      control.getAttribute('aria-label') ||
      '';
  }

  function captureOptions() {
    const options = {};
    const seen = new Set();
    document.querySelectorAll('[data-option-id]').forEach(option => {
      const id = option.dataset.optionId;
      if (!id || seen.has(id)) return;
      seen.add(id);
      if (isProductConfigurationOption(option)) return;
      const controls = editableControls(option);
      options[id] = controls.map(control => {
        const tag = control.tagName.toLowerCase();
        const type = control.type || '';
        const peers = controls.filter(candidate =>
          candidate.tagName.toLowerCase() === tag && (candidate.type || '') === type
        );
        return {
          tag,
          type,
          name: control.name || '',
          id: control.id || '',
          dataKey: controlDataKey(control),
          ordinal: peers.indexOf(control),
          value: control.value,
          checked: control instanceof HTMLInputElement && /^(radio|checkbox)$/.test(control.type)
            ? control.checked
            : undefined
        };
      });
    });
    return options;
  }

  function fontOptionRoot() {
    const candidates = Array.from(document.querySelectorAll(`[data-option-id="${FONT_OPTION_ID}"]`));
    return candidates.find(candidate => candidate.offsetParent !== null) || candidates[0] || null;
  }

  function normalizeFontFamily(value) {
    return String(value || '')
      .replace(/^["']|["']$/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  function captureFontFamily() {
    const option = fontOptionRoot();
    const value = option?.querySelector('select')?.value ||
      option?.querySelector('input[type="hidden"]')?.value ||
      option?.querySelector('button[aria-haspopup="listbox"]')?.innerText ||
      document.querySelector('[data-smoof-text-content]')?.style.fontFamily?.split(',')[0] ||
      '';
    return normalizeFontFamily(value);
  }

  function ensureGoogleFont(family) {
    const clean = normalizeFontFamily(family);
    if (!clean || !/^[a-z0-9 ._-]+$/i.test(clean)) return false;
    if (window.SmoofCustomFontRegistry?.isCustomFamily?.(clean)) {
      window.SmoofCustomFontRegistry.ensureLoaded(clean).then(() => {
        window.SmoofDesignRenderer?.scheduleRender?.();
        window.dispatchEvent(new CustomEvent('smoof:font-restored', { detail: { family: clean, custom: true } }));
      });
      return true;
    }
    const key = clean.toLowerCase();
    let link = Array.from(document.querySelectorAll('link[data-smoof-design-google-font]'))
      .find(candidate => candidate.dataset.smoofDesignGoogleFont === key);
    if (!link) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.dataset.smoofDesignGoogleFont = key;
      const encoded = encodeURIComponent(clean).replace(/%20/g, '+');
      link.href = `https://fonts.googleapis.com/css2?family=${encoded}:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap`;
      document.head.appendChild(link);
    }
    const notifyReady = () => {
      [300, 400, 700].forEach(weight => {
        document.fonts?.load?.(`${weight} 16px "${clean}"`);
        document.fonts?.load?.(`italic ${weight} 16px "${clean}"`);
      });
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:font-restored', { detail: { family: clean } }));
    };
    if (link.sheet) notifyReady();
    else link.addEventListener('load', notifyReady, { once: true });
    return true;
  }

  function applyFontFamily(family) {
    const clean = normalizeFontFamily(family);
    if (!clean) return false;
    const option = fontOptionRoot();
    if (!option) return false;
    const select = option.querySelector('select');
    let control = select || option.querySelector('input[type="hidden"]');
    if (select) {
      const match = Array.from(select.options).find(item =>
        normalizeFontFamily(item.value).toLowerCase() === clean.toLowerCase() ||
        normalizeFontFamily(item.textContent).toLowerCase() === clean.toLowerCase()
      );
      if (match) nativeValue(select, match.value);
      else {
        const restoredOption = document.createElement('option');
        restoredOption.value = clean;
        restoredOption.textContent = clean;
        restoredOption.dataset.smoofRestoredFontOption = 'true';
        select.appendChild(restoredOption);
        nativeValue(select, clean);
      }
    } else {
      if (!control) {
        control = document.createElement('input');
        control.type = 'hidden';
        control.dataset.smoofDesignFontValue = 'true';
        option.appendChild(control);
      }
      nativeValue(control, clean);
    }
    notifyControl(control);
    option.dataset.smoofRestoredFontFamily = clean;
    ensureGoogleFont(clean);
    window.dispatchEvent(new CustomEvent('smoof:font-selected', { detail: { family: clean, restored: true } }));
    return true;
  }

  // Easify owns the conditional number inputs. A checked setter alone does
  // not mount them; activate through its click handler before replaying values.
  async function prepareNumberOptions(savedOptions) {
    const fields = window.SmoofProductProfiles?.current?.fields;
    const saved = savedOptions?.[fields?.numberEnabled]?.find(control => control.type === 'checkbox');
    if (!saved) return;
    const rootFor = id => {
      const roots = Array.from(document.querySelectorAll(`[data-option-id="${CSS.escape(id)}"]`));
      return roots.find(root => root.offsetParent !== null) || roots[0];
    };
    const checkbox = () => rootFor(fields.numberEnabled)?.querySelector('input[type="checkbox"]');
    const wanted = Boolean(saved.checked);
    const input = checkbox();
    if (input && !input.disabled && input.checked !== wanted) input.click();
    const ready = () => {
      const current = checkbox();
      if (!current || current.checked !== wanted) return false;
      if (!wanted) return true;
      return ['numberText', 'numberStyle', 'numberColor'].every(key => {
        const id = fields[key];
        const expected = savedOptions[id];
        if (!Array.isArray(expected)) return true;
        const root = rootFor(id);
        if (!root) return false;
        const controls = editableControls(root);
        return expected.filter(control => control.type !== 'hidden').every(control =>
          controls.some(candidate => candidate.tagName.toLowerCase() === control.tag &&
            (candidate.type || '') === (control.type || ''))
        );
      });
    };
    const deadline = Date.now() + 1200;
    while (!ready() && Date.now() < deadline) {
      await new Promise(resolve => setTimeout(resolve, 25));
    }
    if (!ready()) throw new Error(t(
      'Die Tischnummer konnte nicht vollständig geladen werden. Bitte die Seite neu laden und die Datei erneut öffnen.',
      'The table number could not be fully loaded. Please reload the page and open the file again.'
    ));
  }

  function applyOptions(savedOptions) {
    Object.entries(savedOptions || {}).forEach(([id, savedControls]) => {
      const candidates = Array.from(document.querySelectorAll(`[data-option-id="${CSS.escape(id)}"]`));
      const option = candidates.find(candidate => candidate.offsetParent !== null) || candidates[0];
      if (!option || !Array.isArray(savedControls)) return;
      if (isProductConfigurationOption(option)) return;
      const controls = editableControls(option);
      savedControls.forEach(saved => {
        const matchingType = controls.filter(candidate =>
          candidate.tagName.toLowerCase() === saved.tag &&
          (candidate.type || '') === (saved.type || '')
        );
        let control = null;
        if (/^(radio|checkbox)$/.test(saved.type)) {
          control = matchingType.find(candidate =>
            candidate instanceof HTMLInputElement &&
            candidate.value === saved.value
          ) || null;
        } else {
          if (saved.name) control = matchingType.find(candidate => candidate.name === saved.name) || null;
          if (!control && saved.id) control = matchingType.find(candidate => candidate.id === saved.id) || null;
          if (!control && saved.dataKey) {
            control = matchingType.find(candidate => controlDataKey(candidate) === saved.dataKey) || null;
          }
          if (!control) control = matchingType[Number(saved.ordinal) || 0] || null;
        }
        if (!control) return;
        if (id === window.SmoofProductProfiles?.current?.fields?.numberEnabled && saved.type === 'checkbox') return;
        if (/^(radio|checkbox)$/.test(saved.type)) nativeChecked(control, Boolean(saved.checked));
        else nativeValue(control, String(saved.value ?? ''));
        notifyControl(control);
      });
    });
  }

  function captureProperties() {
    const properties = {};
    (productForm() || document).querySelectorAll('input[name^="properties[_SMOOF"]').forEach(input => {
      if (input.name === 'properties[_SMOOF Design State]') return;
      if (PRODUCT_CONFIGURATION_PROPERTIES.has(input.name)) return;
      if (input.type === 'file') return;
      properties[input.name] = input.value;
    });
    return properties;
  }

  function applyProperties(properties) {
    const form = productForm();
    if (!form) return;
    Object.entries(properties || {}).forEach(([name, value]) => {
      if (!/^properties\[_SMOOF [^\]]+\]$/.test(name)) return;
      if (PRODUCT_CONFIGURATION_PROPERTIES.has(name) || name === EXTRA_JSON_PROPERTY || name === EXTRA_COUNT_PROPERTY) return;
      const matchingInputs = Array.from(form.querySelectorAll('input')).filter(candidate => candidate.name === name);
      if (matchingInputs.some(candidate => candidate.type === 'file')) return;
      let input = matchingInputs[0] || null;
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.dataset.smoofDesignFileProperty = 'true';
        form.appendChild(input);
      }
      nativeValue(input, String(value ?? ''));
      notifyControl(input);
    });
  }

  const EXTRA_JSON_PROPERTY = 'properties[_SMOOF Zusatzpiktogramme JSON]';
  const EXTRA_COUNT_PROPERTY = 'properties[_SMOOF Zusatzpiktogramme Anzahl]';

  function extraPictogramState(design) {
    const invalid = () => new Error(t('Die gespeicherten Extra-Piktogramme sind ungültig.', 'The saved extra pictograms are invalid.'));
    const canonical = Object.prototype.hasOwnProperty.call(design, 'customPictograms');
    let record = design.customPictograms;
    if (!canonical && Object.prototype.hasOwnProperty.call(design.properties || {}, EXTRA_JSON_PROPERTY)) {
      try { record = JSON.parse(design.properties[EXTRA_JSON_PROPERTY]); } catch (_) { throw invalid(); }
      if (!record || !Array.isArray(record.items)) throw invalid();
    }
    const items = canonical ? (record == null ? [] : record.states) : (record?.items || []);
    if (!Array.isArray(items) || items.length > 3 || (record && record.version !== 1)) throw invalid();
    const states = Array.from({ length: 3 }, (_, index) => ({ id: `custom-pictogram-${index + 1}`, enabled: false }));
    const seen = new Set();
    items.forEach((item, index) => {
      if (!item || typeof item !== 'object' || Array.isArray(item)) throw invalid();
      const id = item.id || (canonical ? `custom-pictogram-${index + 1}` : '');
      if (!/^custom-pictogram-[1-3]$/.test(id) || seen.has(id)) throw invalid();
      seen.add(id);
      if (item.customSvg != null && typeof item.customSvg !== 'string') throw invalid();
      if (item.customSvg && (!window.SmoofPictogramLibrary?.sanitizeSvg?.(item.customSvg))) throw invalid();
      states[Number(id.slice(-1)) - 1] = { ...item, id };
    });
    return { version: 1, states };
  }

  // All file versions and catalogue restores share this boundary, including same-product loads.
  function applyExtraPictogramPolicy(design, restrictions) {
    const profile = window.SmoofProductProfiles?.current;
    if (!profile?.editorPolicy?.forceMonochromeLaser || window.SmoofProductVariant?.get?.()?.printProcess !== 'laser') return;
    design.customPictograms.states.forEach((state, index) => {
      state.color = '#000000';
      if (!state.customSvg) return;
      const svg = new DOMParser().parseFromString(state.customSvg, 'image/svg+xml');
      const external = Array.from(svg.querySelectorAll('[href], [xlink\\:href]')).some(node => {
        const href = node.getAttribute('href') || node.getAttribute('xlink:href') || '';
        return href && !href.startsWith('#');
      });
      if (svg.querySelector('parsererror, image, text, tspan, foreignObject, script, video, canvas, iframe') || external || /url\(\s*["']?(?!#)/i.test(state.customSvg)) {
        design.customPictograms.states[index] = { id: state.id, enabled: false };
        restrictions.push(`extra-pictogram-removed-laser-vector-required:${state.id}`);
      }
    });
  }

  function captureSnapshot() {
    window.SmoofCustomPictogramTools?.syncProperties?.();
    const bridgeBackground = window.SmoofBackgroundImageBridge?.getState?.();
    const toolBackground = window.SmoofBackgroundImageTools?.getState?.();
    return {
      groups: window.SmoofMultiSelection?.getGroups?.() || [],
      options: captureOptions(),
      properties: captureProperties(),
      fontFamily: captureFontFamily(),
      textLayout: window.SmoofTextTools?.getHistoryState?.() || null,
      customTexts: window.SmoofCustomTextTools?.getHistoryState?.() || null,
      textVisibility: window.SmoofTextVisibility
        ? [0, 1, 2].map(index => window.SmoofTextVisibility.isVisible(index) !== false)
        : null,
      logo: window.SmoofLogoHistory?.getState?.() || null,
      logoCopy: window.SmoofLogoCopyTools?.getHistoryState?.() || null,
      logoDuplicate: window.SmoofLogoDuplicateTools?.getHistoryState?.() || null,
      logoBackgrounds: window.SmoofLogoBackgroundTools?.getHistoryState?.() || null,
      logoInversion: window.SmoofLogoInvertTools?.getHistoryState?.() || null,
      logoColours: window.SmoofLogoColourTools?.getHistoryState?.() || null,
      backgroundImage: bridgeBackground?.hasImage ? bridgeBackground : toolBackground || bridgeBackground || null,
      backgroundGradient: window.SmoofBackgroundGradientTools?.getHistoryState?.() || null,
      number: window.SmoofNumberHistory?.getState?.() || null,
      branding: window.SmoofBrandTools?.getHistoryState?.() || window.SmoofBrandTools?.getState?.() || null,
      arrows: window.SmoofArrowTools?.getHistoryState?.() || null,
      customPictograms: window.SmoofCustomPictogramTools?.getHistoryState?.() || null,
      payments: window.SmoofPaymentTools?.getHistoryState?.() || null,
      socialPlatforms: window.SmoofSocialPlatformTools?.getHistoryState?.() || null,
      nfc: window.SmoofNfcTools?.getHistoryState?.() || window.SmoofNfcTools?.getState?.() || null,
      qr: window.SmoofQrGeometryTools?.getHistoryState?.() || window.SmoofQrGeometryTools?.getState?.() || null,
      layerOpacity: window.SmoofLayerOpacityTools?.getHistoryState?.() || null
    };
  }

  function cleanForJson(value) {
    return JSON.parse(JSON.stringify(value, (key, item) => {
      if (typeof File !== 'undefined' && item instanceof File) return undefined;
      if (typeof Blob !== 'undefined' && item instanceof Blob) return undefined;
      return item;
    }));
  }

  function timestamp() {
    const date = new Date();
    const part = value => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${part(date.getMonth() + 1)}-${part(date.getDate())}-${part(date.getHours())}${part(date.getMinutes())}`;
  }

  function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(String(reader.result || '')), { once: true });
      reader.addEventListener('error', () => reject(reader.error || new Error('Image could not be read')), { once: true });
      reader.readAsDataURL(blob);
    });
  }

  async function normalizedBackgroundState(saved) {
    await window.SmoofBackgroundImageBridge?.sync?.();
    const bridged = window.SmoofBackgroundImageBridge?.getState?.();
    const current = bridged?.hasImage ? bridged : saved;
    if (!current?.hasImage) return current || null;
    const source = String(current.dataUrl || current.src || current.url || '');
    if (IMAGE_DATA_URL.test(source)) return { ...current, dataUrl: source };
    if (!/^(blob:|https?:)/i.test(source)) {
      throw new Error(t('Das Hintergrundbild ist noch nicht vollständig geladen. Bitte kurz warten und erneut speichern.', 'The background image has not finished loading. Please wait briefly and save again.'));
    }
    const response = await fetch(source);
    if (!response.ok) throw new Error(t('Das Hintergrundbild konnte nicht gelesen werden.', 'The background image could not be read.'));
    const imageBlob = await response.blob();
    if (!/^image\//i.test(imageBlob.type)) {
      throw new Error(t('Die Hintergrunddatei ist kein unterstütztes Bild.', 'The background file is not a supported image.'));
    }
    return {
      ...current,
      hasImage: true,
      dataUrl: await blobToDataUrl(imageBlob),
      mimeType: imageBlob.type
    };
  }

  async function saveFile({ download = true, fileName = `SMOOF-Design-${timestamp()}.smoofdesign` } = {}) {
    try {
      if (!window.SmoofCustomPictogramTools?.getHistoryState) {
        throw new Error(t('Die Extra-Piktogramme sind noch nicht geladen. Bitte warten Sie kurz und versuchen Sie es erneut.', 'Extra pictograms are not loaded yet. Please wait briefly and try again.'));
      }
      const captureDesign = async () => {
        const design = captureSnapshot();
        design.backgroundImage = await normalizedBackgroundState(design.backgroundImage);
        return cleanForJson(design);
      };
      let design, surfaces;
      if (isDoubleSided()) {
        const store = requireSurfaceStore();
        surfaces = await store.withSurfaces(async session => {
          const pair = {};
          for (const side of ['front', 'back']) {
            await session.visit(side);
            pair[side] = await captureDesign();
          }
          return pair;
        }, { resetHistory: false });
      } else design = await captureDesign();
      const payload = cleanForJson({
        format: FORMAT,
        version: /"textAlign":"justify"/.test(JSON.stringify(surfaces||design)) ? (surfaces?16:15) : /"textAlign":"(?:left|right)"/.test(JSON.stringify(surfaces||design)) ? (surfaces?14:13) : (surfaces?Object.values(surfaces):[design]).some(side=>Object.values(side.arrows||{}).some(a=>a?.label?.version===1)) ? (surfaces?12:11) : (surfaces?Object.values(surfaces):[design]).some(side=>side.groups?.length) ? (surfaces?10:9) : window.SmoofCurvedText.hasCurves(surfaces||design) ? (surfaces?8:7) : /\"runs\":\[\{/.test(JSON.stringify(surfaces||design)) ? (surfaces?6:5) : (surfaces?4:3),
        savedAt: new Date().toISOString(),
        product: {
          handle,
          variantId: productForm()?.querySelector('[name="id"]')?.value || '',
          diameterMm: window.SmoofProductVariant?.get?.()?.diameterMm || null
        },
        productConfiguration: capturePortableProductConfiguration(),
        customFonts: window.SmoofCustomFontRegistry?.exportRecords?.() || [],
        ...(surfaces ? { surfaces } : { design })
      });
      validate(payload);
      const encoded = JSON.stringify(payload, null, 2);
      if (new Blob([encoded]).size > MAX_FILE_BYTES) throw new Error(t('Die Datei ist zu groß.', 'The file is too large.'));
      if (!download) return payload;
      const blob = new Blob([encoded], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      lastFileName = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      showStatus(t('Design-Datei gespeichert', 'Design file saved'));
      window.dispatchEvent(new CustomEvent('smoof:design-file-saved', { detail: { payload } }));
      return payload;
    } catch (error) {
      showStatus(error.message || t('Das Design konnte nicht gespeichert werden.', 'The design could not be saved.'), true);
      return false;
    }
  }

  function validateImageState(state, label) {
    if (!state) return;
    const source = String(state.dataUrl || state.src || '');
    if (!source) return;
    if (!IMAGE_DATA_URL.test(source)) throw new Error(t(`${label}: nicht unterstützte Bilddaten.`, `${label}: unsupported image data.`));
    if (source.length > MAX_FILE_BYTES) throw new Error(t(`${label}: Bilddatei zu groß.`, `${label}: image too large.`));
  }

  function validate(payload) {
    if (!payload || payload.format !== FORMAT) throw new Error(t('Keine gültige SMOOF-Designdatei.', 'Not a valid SMOOF design file.'));
    if ([5,6,7,8,9,10,11,12,13,14,15,16].includes(Number(payload.version)) && !window.SmoofRichText) throw new Error(t('Die Textformatierung lädt noch. Bitte erneut versuchen.', 'Text formatting is still loading. Please try again.'));
    if ([7,8,9,10,11,12,13,14,15,16].includes(Number(payload.version)) && !window.SmoofCurvedText) throw new Error(t('Die Textformen laden noch. Bitte erneut versuchen.', 'Text shapes are still loading. Please try again.'));
    if (!SUPPORTED_VERSIONS.has(Number(payload.version))) throw new Error(t('Diese Dateiversion wird noch nicht unterstützt.', 'This file version is not supported.'));
    if ([4,6,8,10,12,14,16].includes(Number(payload.version))) {
      if (!payload.surfaces || Array.isArray(payload.surfaces) || Object.keys(payload.surfaces).sort().join(',') !== 'back,front') throw new Error(t('Vorder- und Rückseite fehlen oder sind ungültig.', 'Front and back designs are missing or invalid.'));
      for (const side of ['front', 'back']) {
        const single = singleSidePayload(payload, side);
        validate(single);
        extraPictogramState(single.design);
      }
      return payload;
    }
    if (!payload.design || typeof payload.design !== 'object' || Array.isArray(payload.design)) throw new Error(t('Die Designdaten fehlen.', 'The design data is missing.'));
    if(payload.design.groups!==undefined){
      const groups=payload.design.groups,seen=new Set();
      if(!Array.isArray(groups)||groups.length>64||groups.some(group=>!Array.isArray(group)||group.length<2||group.length>64||group.some(id=>{if(typeof id!=='string'||!/^(text-[0-2]|custom-text-[1-3]|custom-pictogram-[1-3]|table-number|branding-dot|arrow-(left|right)|qr|nfc|logo|logo-copy|logo-2|payments|social-platform-[a-z0-9_-]+)$/.test(id)||seen.has(id))return true;seen.add(id);return false;})))throw new Error(t('Die gespeicherten Gruppen sind ungültig.','The saved groups are invalid.'));
    }
    for(const state of Object.values(payload.design.arrows||{})) if(state?.label!==undefined) window.SmoofArrowLabels.validate(state.label);
    validateImageState(payload.design.logo, 'Logo');
    validateImageState(payload.design.logoDuplicate, 'Logo 2');
    validateImageState(payload.design.backgroundImage, 'Background');
    if (payload.design.fontFamily && !/^[a-z0-9 ._-]{1,100}$/i.test(payload.design.fontFamily)) {
      throw new Error(t('Der gespeicherte Schriftname ist ungültig.', 'The saved font name is invalid.'));
    }
    if (Number(payload.version) >= 2 && !Array.isArray(payload.customFonts)) {
      throw new Error(t('Die eingebetteten Schriftdaten sind ungültig.', 'The embedded font data is invalid.'));
    }
    if (Number(payload.version) >= 3) {
      const configuration = payload.productConfiguration;
      if (!configuration || typeof configuration !== 'object' || Array.isArray(configuration) ||
          configuration.schema !== PRODUCT_CONFIGURATION_SCHEMA) {
        throw new Error(t('Die gespeicherten Produkteinstellungen sind ungültig.', 'The saved product settings are invalid.'));
      }
      if (Object.prototype.hasOwnProperty.call(configuration, 'nfcCode') &&
          !['with_nfc', 'without_nfc'].includes(configuration.nfcCode)) {
        throw new Error(t('Die gespeicherte NFC-Einstellung ist ungültig.', 'The saved NFC setting is invalid.'));
      }
      if (Object.prototype.hasOwnProperty.call(configuration, 'diameterMm') &&
          (!Number.isFinite(Number(configuration.diameterMm)) || Number(configuration.diameterMm) <= 0 || Number(configuration.diameterMm) > 1000)) {
        throw new Error(t('Das gespeicherte Druckformat ist ungültig.', 'The saved print size is invalid.'));
      }
      ['materialKind', 'materialCode', 'printProcess'].forEach(key => {
        if (Object.prototype.hasOwnProperty.call(configuration, key) &&
            !/^[a-z0-9_-]{1,50}$/.test(String(configuration[key] || ''))) {
          throw new Error(t('Eine gespeicherte Produkteinstellung ist ungültig.', 'A saved product setting is invalid.'));
        }
      });
    }
    (payload.customFonts || []).forEach(item => {
      if (!item || typeof item !== 'object' || !/^cf-[0-9a-f]{24}$/.test(String(item.id || ''))) {
        throw new Error(t('Ein eingebetteter Fontdatensatz ist ungültig.', 'An embedded font record is invalid.'));
      }
      if (!/^data:font\/(?:ttf|otf|sfnt|truetype|opentype);base64,/i.test(String(item.dataUrl || ''))) {
        throw new Error(t('Eine eingebettete Schrift enthält ungültige Daten.', 'An embedded font contains invalid data.'));
      }
      if (String(item.dataUrl).length > (4 * 1024 * 1024 + 4096)) {
        throw new Error(t('Eine eingebettete Schrift ist zu groß.', 'An embedded font is too large.'));
      }
    });
    return payload;
  }

  function preparePayload(payload) {
    const sourceHandle = String(payload.product?.handle || '');
    if (!sourceHandle || sourceHandle === handle) {
      return { payload, restrictions: [], crossProduct: false, sourceHandle };
    }
    if (!window.SmoofProductProfiles?.get?.(sourceHandle)) {
      throw new Error(t(
        'Die Datei gehört zu einem nicht unterstützten SMOOF-Produkt.',
        'The file belongs to an unsupported SMOOF product.'
      ));
    }
    const prepared = window.SmoofTemplateLibrary?.preparePayload?.(payload);
    if (!prepared?.payload || prepared.payload.product?.handle !== handle) {
      throw new Error(t(
        'Die Produktanpassung ist noch nicht geladen. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
        'Product adaptation is not loaded yet. Please reload the page and try again.'
      ));
    }
    return { ...prepared, crossProduct: true, sourceHandle };
  }

  function inspectSource(payload) {
    const sourceHandle = String(payload.product?.handle || '');
    const crossProduct = Boolean(sourceHandle && sourceHandle !== handle);
    if (crossProduct && !window.SmoofProductProfiles?.get?.(sourceHandle)) {
      throw new Error(t(
        'Die Datei gehört zu einem nicht unterstützten SMOOF-Produkt.',
        'The file belongs to an unsupported SMOOF product.'
      ));
    }
    if (crossProduct && typeof window.SmoofTemplateLibrary?.preparePayload !== 'function') {
      throw new Error(t(
        'Die Produktanpassung ist noch nicht geladen. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
        'Product adaptation is not loaded yet. Please reload the page and try again.'
      ));
    }
    return { sourceHandle, crossProduct };
  }

  function dataUrlFile(dataUrl, fileName) {
    const comma = dataUrl.indexOf(',');
    if (comma < 0) return null;
    const header = dataUrl.slice(0, comma);
    const mime = header.match(/^data:([^;,]+)/i)?.[1] || 'image/png';
    const encoded = dataUrl.slice(comma + 1);
    const bytes = /;base64/i.test(header)
      ? Uint8Array.from(atob(encoded), character => character.charCodeAt(0))
      : new TextEncoder().encode(decodeURIComponent(encoded));
    return new File([bytes], fileName || 'background.png', { type: mime });
  }

  function backgroundFileInput() {
    const bridged = window.SmoofBackgroundImageBridge?.input?.();
    if (bridged) return bridged;
    const direct = document.querySelector([
      '[data-smoof-background-file-input]',
      '[data-smoof-background-upload] input[type="file"]',
      'input[type="file"][name*="Hintergrund"]',
      'input[type="file"][name*="background" i]'
    ].join(','));
    return direct || null;
  }

  async function applyBackgroundImage(saved) {
    const bridge = window.SmoofBackgroundImageBridge;
    if (typeof bridge?.applyState === 'function') {
      const restored = await bridge.applyState(saved);
      if (restored !== false) return true;
    }
    const tools = window.SmoofBackgroundImageTools;
    if (!saved?.hasImage || !saved.dataUrl) {
      tools?.remove?.();
      return true;
    }
    for (const method of ['applyHistoryState', 'applyState', 'restoreState', 'setState']) {
      if (typeof tools?.[method] === 'function') {
        const result = await tools[method](saved);
        if (result !== false) return true;
      }
    }
    const input = backgroundFileInput();
    const file = dataUrlFile(saved.dataUrl, saved.fileName || 'background.png');
    if (!input || !file || typeof DataTransfer !== 'function') return false;
    try {
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      notifyControl(input);
      return true;
    } catch (error) {
      return false;
    }
  }

  function applyTextVisibility(saved) {
    (Array.isArray(saved) ? saved : []).forEach((visible, index) => {
      if (!window.SmoofTextVisibility) return;
      if (window.SmoofTextVisibility.isVisible(index) !== Boolean(visible)) {
        window.SmoofTextVisibility.toggle(index);
      }
    });
  }

  function applyToolStates(design) {
    if (design.fontFamily) applyFontFamily(design.fontFamily);
    if (design.textLayout) window.SmoofTextTools?.applyHistoryState?.(design.textLayout);
    if (design.customTexts) window.SmoofCustomTextTools?.applyHistoryState?.(design.customTexts);
    if (design.logo) window.SmoofLogoHistory?.applyState?.(design.logo);
    if (design.logoCopy) window.SmoofLogoCopyTools?.applyHistoryState?.(design.logoCopy);
    if (design.logoDuplicate) window.SmoofLogoDuplicateTools?.applyHistoryState?.(design.logoDuplicate);
    if (design.logoBackgrounds) window.SmoofLogoBackgroundTools?.applyHistoryState?.(design.logoBackgrounds);
    if (design.logoInversion) window.SmoofLogoInvertTools?.applyHistoryState?.(design.logoInversion);
    // Restore after the upload sources; legacy files must clear a previous tint.
    window.SmoofLogoColourTools?.applyHistoryState?.(design.logoColours || {});
    if (design.backgroundGradient) window.SmoofBackgroundGradientTools?.applyHistoryState?.(design.backgroundGradient);
    if (design.number) window.SmoofNumberHistory?.applyState?.(design.number);
    if (design.branding) (window.SmoofBrandTools?.applyHistoryState || window.SmoofBrandTools?.applyState)?.call(window.SmoofBrandTools, design.branding);
    if (design.arrows) window.SmoofArrowTools?.applyHistoryState?.(design.arrows);
    if (window.SmoofCustomPictogramTools) {
      if (window.SmoofCustomPictogramTools.applyHistoryState(design.customPictograms) === false) {
        throw new Error(t('Die Extra-Piktogramme konnten nicht geladen werden.', 'Extra pictograms could not be restored.'));
      }
      window.SmoofCustomPictogramTools.syncProperties?.();
    }
    if (design.payments) window.SmoofPaymentTools?.applyHistoryState?.(design.payments);
    if (design.socialPlatforms) window.SmoofSocialPlatformTools?.applyHistoryState?.(design.socialPlatforms);
    if (design.qr) window.SmoofQrGeometryTools?.applyHistoryState?.(design.qr);
    if (design.nfc) (window.SmoofNfcTools?.applyHistoryState || window.SmoofNfcTools?.applyState)?.call(window.SmoofNfcTools, design.nfc);
    if (design.layerOpacity) window.SmoofLayerOpacityTools?.applyHistoryState?.(design.layerOpacity);
    applyTextVisibility(design.textVisibility);
    window.SmoofMultiSelection?.restoreGroups?.(design.groups || []);
  }

  async function restoreSingle(payload, { confirmReplace = true, applyProductConfiguration = true, quiet = false, onRestored = null, importRestrictions = [] } = {}) {
    validate(payload);
    const requestedPayload = payload;
    payload = cleanForJson(payload);
    payload.design.customPictograms = extraPictogramState(payload.design);
    if (!window.SmoofCustomPictogramTools?.applyHistoryState && payload.design.customPictograms.states.some(state => state.enabled)) {
      throw new Error(t('Die Extra-Piktogramme sind noch nicht geladen. Bitte warten Sie kurz und versuchen Sie es erneut.', 'Extra pictograms are not loaded yet. Please wait briefly and try again.'));
    }
    const source = inspectSource(payload);
    const includesProductConfiguration = applyProductConfiguration !== false && Number(payload.version) >= 3 && Boolean(payload.productConfiguration);
    const confirmation = source.crossProduct
      ? t(
          `Die Datei wurde für ein anderes SMOOF-Produkt erstellt. Sie wird an dieses Produkt und seine technischen Vorgaben angepasst${includesProductConfiguration ? ' und übernimmt kompatible Produkteinstellungen' : ''}. Das aktuelle Design wird ersetzt. Möchten Sie die Datei wirklich öffnen?`,
          `This file was created for another SMOOF product. It will be adapted to this product and its technical requirements${includesProductConfiguration ? ' and will apply compatible product settings' : ''}. The current design will be replaced. Do you want to open the file?`
        )
      : t(
          `Das aktuelle Design wird ersetzt${includesProductConfiguration ? ' und die gespeicherten Produkteinstellungen werden übernommen' : ''}. Möchten Sie die Datei wirklich öffnen?`,
          `The current design will be replaced${includesProductConfiguration ? ' and the saved product settings will be applied' : ''}. Do you want to open this file?`
        );
    if (confirmReplace && !window.confirm([confirmation, laserImportNotice(payload, includesProductConfiguration)].filter(Boolean).join('\n\n'))) {
      return false;
    }
    window.SmoofRichText?.clear?.();
    const originalProductConfiguration = captureProductConfiguration();
    const surfaceStore = window.SmoofSurfaceStore;
    let surfaceTransaction = null;
    let productConfigurationResult = null;
    try {
      if (includesProductConfiguration) {
        productConfigurationResult = await applyPortableProductConfiguration(payload.productConfiguration);
      }
      const prepared = preparePayload(payload);
      prepared.restrictions.push(...importRestrictions);
      const restoredPayload = prepared.payload;
      applyExtraPictogramPolicy(restoredPayload.design, prepared.restrictions);
      // Derived properties must never replay stale/coloured legacy data over component state.
      if (restoredPayload.design.properties) {
        delete restoredPayload.design.properties[EXTRA_JSON_PROPERTY];
        delete restoredPayload.design.properties[EXTRA_COUNT_PROPERTY];
      }
      surfaceTransaction = surfaceStore?.beginExternalApply?.('design-file') || null;
      if ((restoredPayload.customFonts || []).length) {
        if (!window.SmoofCustomFontRegistry?.importRecords) {
          throw new Error(t('Die Verwaltung eigener Schriften ist noch nicht geladen. Bitte die Seite neu laden.', 'Custom-font support is not loaded yet. Please reload the page.'));
        }
        await window.SmoofCustomFontRegistry.importRecords(restoredPayload.customFonts);
      }
      const design = restoredPayload.design;
      await prepareNumberOptions(design.options);
      applyOptions(design.options);
      applyProperties(design.properties);
      applyToolStates(design);
      const backgroundRestored = await applyBackgroundImage(design.backgroundImage);
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      await prepareNumberOptions(design.options);
      applyOptions(design.options);
      applyProperties(design.properties);
      applyToolStates(design);
      if (!includesProductConfiguration) restoreProductConfiguration(originalProductConfiguration);
      if (design.backgroundImage?.hasImage && !backgroundRestored) {
        throw new Error(t('Das Hintergrundbild konnte nicht wiederhergestellt werden.', 'The background image could not be restored.'));
      }
      await new Promise(resolve => setTimeout(resolve, 260));
      applyToolStates(design);
      if (!includesProductConfiguration) restoreProductConfiguration(originalProductConfiguration);
      window.SmoofDesignRenderer?.scheduleRender?.();
      surfaceStore?.finishExternalApply?.(surfaceTransaction, true);
      const productRestrictions = (productConfigurationResult?.ignored || [])
        .map(item => `product-configuration:${item}`);
      onRestored?.({ restrictions: [...prepared.restrictions, ...productRestrictions] });
      if (!quiet) {
        window.dispatchEvent(new CustomEvent('smoof:design-file-loaded', {
          detail: {
            payload: restoredPayload,
            requestedPayload,
            sourceHandle: prepared.sourceHandle,
            targetHandle: handle,
            restrictions: [...prepared.restrictions, ...productRestrictions],
            productConfiguration: productConfigurationResult
          }
        }));
        importStatus(productRestrictions.length
          ? t('Design geöffnet; nicht verfügbare Produkteinstellungen wurden beibehalten.', 'Design opened; unavailable product settings were retained.')
          : prepared.crossProduct
            ? t('Design erfolgreich für dieses Produkt geöffnet.', 'Design adapted and opened successfully.')
            : t('Design erfolgreich geöffnet.', 'Design opened successfully.'), prepared.restrictions);
      }
      return true;
    } catch (error) {
      surfaceStore?.finishExternalApply?.(surfaceTransaction, false);
      if (includesProductConfiguration) {
        restoreProductConfiguration(originalProductConfiguration);
        await waitForProductConfiguration(2200);
      }
      throw error;
    }
  }

  function isDoubleSided() {
    return Number(window.SmoofProductProfiles?.current?.surfaceCount) === 2;
  }

  function requireSurfaceStore() {
    const store = window.SmoofSurfaceStore;
    if (typeof store?.withSurfaces !== 'function' || !['front', 'back'].every(side => store.surfaces?.includes(side))) {
      throw new Error(t('Die Seitenverwaltung ist noch nicht bereit. Bitte die Seite neu laden.', 'Side management is not ready. Please reload the page.'));
    }
    return store;
  }

  function singleSidePayload(payload, side) {
    const { surfaces, ...metadata } = payload;
    return { ...metadata, version: /"textAlign":"justify"/.test(JSON.stringify(surfaces[side])) ? 15 : /"textAlign":"(?:left|right)"/.test(JSON.stringify(surfaces[side])) ? 13 : Object.values(surfaces[side].arrows||{}).some(a=>a?.label?.version===1) ? 11 : surfaces[side].groups?.length ? 9 : window.SmoofCurvedText?.hasCurves(surfaces[side]) ? 7 : /\"runs\":\[\{/.test(JSON.stringify(surfaces[side])) ? 5 : 3, design: surfaces[side] };
  }

  let fileBusy = false;
  async function fileOperation(callback) {
    if (fileBusy) throw new Error(t('Eine Designdatei wird bereits verarbeitet.', 'A design file is already being processed.'));
    fileBusy = true;
    const cover = document.createElement('div');
    cover.setAttribute('role', 'status');
    cover.setAttribute('aria-live', 'polite');
    cover.textContent = t('Design wird verarbeitet …', 'Processing design …');
    cover.style.cssText = 'position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;background:rgba(255,255,255,.82);color:#171719;font:600 16px sans-serif;cursor:wait';
    const blockInput = event => { if (event.isTrusted) { event.preventDefault(); event.stopImmediatePropagation(); } };
    document.addEventListener('keydown', blockInput, true);
    if (!document.querySelector('[data-smoof-login-draft-status][open]')) document.body.appendChild(cover);
    try { return await callback(); }
    finally { cover.remove(); document.removeEventListener('keydown', blockInput, true); fileBusy = false; }
  }

  let nameDialogPending = false;
  let lastFileName = '';
  let fileReadPending = false;

  function normalizedFileName(value) {
    const stem = String(value).trim().replace(/(?:\.smoofdesign)+$/i, '')
      .replace(/[<>:"/\\|?*\u0000-\u001f\u007f]/g, '-').replace(/[. ]+$/g, '').trim();
    if (!stem) return '';
    const safe = /^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i.test(stem) ? '_' + stem : stem;
    return Array.from(safe).slice(0, 100).join('').replace(/[. ]+$/g, '') + '.smoofdesign';
  }

  function requestFileName() {
    return new Promise(resolve => {
      const previousFocus = document.activeElement;
      const dialog = document.createElement('dialog');
      dialog.dataset.smoofDesignName = '';
      dialog.setAttribute('aria-labelledby', 'smoof-design-name-title');
      dialog.innerHTML = '<form><h2 id="smoof-design-name-title"></h2><label for="smoof-design-name-input"></label><input id="smoof-design-name-input" type="text" maxlength="120" required autocomplete="off" aria-describedby="smoof-design-name-help"><p id="smoof-design-name-help"></p><div><button type="button" data-cancel></button><button type="submit"></button></div></form>';
      dialog.querySelector('h2').textContent = t('Design speichern', 'Save design');
      dialog.querySelector('label').textContent = t('Dateiname', 'File name');
      dialog.querySelector('p').textContent = t('Die Endung .smoofdesign wird automatisch ergänzt.', 'The .smoofdesign extension is added automatically.');
      dialog.querySelector('[data-cancel]').textContent = t('Abbrechen', 'Cancel');
      dialog.querySelector('[type=submit]').textContent = t('Speichern', 'Save');
      const input = dialog.querySelector('input');
      input.value = (lastFileName || `SMOOF-Design-${timestamp()}.smoofdesign`).replace(/\.smoofdesign$/i, '');
      let result = null;
      dialog.addEventListener('close', () => {
        dialog.remove();
        // Panels may rerender and their pointer handlers can preserve focus on the toolbar.
        const saveAction = document.querySelector('[data-smoof-ui-context][data-open="true"] [data-smoof-ui-action="download-design"]');
        const returnFocus = saveAction?.getClientRects().length ? saveAction : previousFocus;
        if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        resolve(result);
      }, { once: true });
      dialog.querySelector('[data-cancel]').addEventListener('click', () => dialog.close());
      input.addEventListener('input', () => input.setCustomValidity(''));
      dialog.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const name = normalizedFileName(input.value);
        if (!name) {
          input.setCustomValidity(t('Bitte geben Sie einen Dateinamen ein.', 'Please enter a file name.'));
          input.reportValidity();
          return;
        }
        result = name;
        dialog.close();
      });
      document.body.appendChild(dialog);
      dialog.showModal();
      input.focus();
      input.select();
    });
  }

  async function save() {
    if (nameDialogPending || fileBusy || fileReadPending) return false;
    // The login recovery dialog owns and locks keyboard input; keep its emergency download dialog-free.
    if (document.querySelector('[data-smoof-login-draft-status][open]')) return fileOperation(saveFile);
    nameDialogPending = true;
    try {
      const fileName = await requestFileName();
      if (!fileName) return false;
      return await fileOperation(() => saveFile({ fileName }));
    } finally { nameDialogPending = false; }
  }

  function restore(payload, options = {}) {
    return fileOperation(async () => {
      validate(payload);
      if (![4,6,8,10,12,14,16].includes(Number(payload.version))) return restoreSingle(payload, options);
      inspectSource(payload);
      const doubleSided = isDoubleSided();
      const store = doubleSided ? requireSurfaceStore() : null;
      const message = doubleSided
        ? t('Vorder- und Rückseite werden durch die Datei ersetzt. Möchten Sie fortfahren?', 'The file will replace both front and back. Continue?')
        : t('Aus dieser doppelseitigen Datei wird nur die Vorderseite übernommen. Das aktuelle Design wird ersetzt. Möchten Sie fortfahren?', 'Only the front of this double-sided file will be used. The current design will be replaced. Continue?');
      if (options.confirmReplace !== false && !window.confirm([message, laserImportNotice(payload, options.applyProductConfiguration !== false)].filter(Boolean).join('\n\n'))) return false;
      window.SmoofRichText?.clear?.();
      const originalConfiguration = captureProductConfiguration();
      const restrictions = [...(options.importRestrictions || [])];
      let productConfiguration = null;
      const rollbackConfiguration = async () => {
        restoreProductConfiguration(originalConfiguration);
        await waitForProductConfiguration(2200);
      };
      const run = async session => {
        if (options.applyProductConfiguration !== false) {
          productConfiguration = await applyPortableProductConfiguration(payload.productConfiguration);
        }
        for (const side of doubleSided ? ['front', 'back'] : ['front']) {
          if (session) await session.visit(side);
          await restoreSingle(singleSidePayload(payload, side), {
            confirmReplace: false,
            applyProductConfiguration: false,
            quiet: true,
            onRestored: result => restrictions.push(...result.restrictions.map(code => `${side}:${code}`))
          });
        }
      };
      if (store) await store.withSurfaces(run, { beforeRollback: rollbackConfiguration });
      else {
        try { await run(null); }
        catch (error) { await rollbackConfiguration(); throw error; }
      }
      window.dispatchEvent(new CustomEvent('smoof:design-file-loaded', {
        detail: { payload, requestedPayload: payload, sourceHandle: payload.product?.handle || '', targetHandle: handle, surfaces: doubleSided ? ['front', 'back'] : ['front'], restrictions, productConfiguration }
      }));
      importStatus(restrictions.length || productConfiguration?.ignored?.length
        ? t('Design geöffnet und an die technischen Vorgaben dieses Produkts angepasst.', 'Design opened and adapted to this product’s technical requirements.')
        : doubleSided
        ? t('Vorder- und Rückseite erfolgreich geöffnet.', 'Front and back opened successfully.')
        : t('Vorderseite erfolgreich geöffnet.', 'Front design opened successfully.'), restrictions);
      return true;
    });
  }

  async function readFile(file) {
    if (!file) return false;
    if (fileReadPending || fileBusy || nameDialogPending) throw new Error(t('Eine Designdatei wird bereits verarbeitet.', 'A design file is already being processed.'));
    fileReadPending = true;
    try {
      if (file.size > MAX_FILE_BYTES) throw new Error(t('Die Datei ist zu groß.', 'The file is too large.'));
      const payload = JSON.parse(await file.text());
      const loaded = await restore(payload);
      if (loaded) lastFileName = normalizedFileName(file.name || '');
      return loaded;
    } finally { fileReadPending = false; }
  }

  function ensurePicker() {
    if (picker?.isConnected) return picker;
    picker = document.createElement('input');
    picker.type = 'file';
    picker.accept = '.smoofdesign,application/json';
    picker.hidden = true;
    picker.dataset.smoofDesignFilePicker = 'true';
    picker.addEventListener('change', async () => {
      const file = picker.files?.[0];
      try {
        await readFile(file);
      } catch (error) {
        showStatus(error.message || t('Die Datei konnte nicht geöffnet werden.', 'The file could not be opened.'), true);
      } finally {
        picker.value = '';
      }
    });
    document.body.appendChild(picker);
    return picker;
  }

  function open() {
    ensurePicker().click();
  }


  function installFileInteractions() {
    const style = document.createElement('style');
    style.textContent = `
      [data-smoof-design-name] { box-sizing:border-box; width:min(440px, calc(100vw - 32px)); max-height:calc(100dvh - 32px); overflow:auto; padding:26px; border:1px solid var(--smoof-ui-stroke); border-radius:22px; background:var(--smoof-ui-drag-bg,#fff); color:var(--smoof-ui-text,#19181c); box-shadow:var(--smoof-ui-shadow); font:inherit; color-scheme:var(--smoof-ui-color-scheme,light); }
      [data-smoof-design-name]::backdrop { background:rgba(0,0,0,.32); }
      [data-smoof-design-name] h2 { margin:0 0 24px; font-size:22px; font-weight:600; line-height:1.25; color:inherit; }
      [data-smoof-design-name] label { display:block; margin-bottom:8px; font-weight:600; }
      [data-smoof-design-name] input { box-sizing:border-box; width:100%; min-height:44px; padding:10px 12px; border:1px solid var(--smoof-ui-stroke-strong); border-radius:10px; background:var(--smoof-ui-control); color:inherit; font:inherit; }
      [data-smoof-design-name] p { margin:10px 0 24px; font-size:13px; line-height:1.5; color:var(--smoof-ui-muted); }
      [data-smoof-design-name] form>div { display:flex; justify-content:flex-end; flex-wrap:wrap; gap:10px; }
      [data-smoof-design-name] button { min-height:44px; padding:10px 18px; border:1px solid var(--smoof-ui-stroke); border-radius:12px; background:var(--smoof-ui-control); color:inherit; font:inherit; cursor:pointer; }
      [data-smoof-design-name] button[type=submit] { background:#19181c; color:#fff; }
      [data-smoof-design-name] :focus-visible { outline:2px solid var(--smoof-ui-accent,#eb008b); outline-offset:3px; }
      [data-smoof-design-drop] { position:fixed; z-index:2147483646; display:grid; place-items:center; padding:20px; box-sizing:border-box; border:3px dashed var(--smoof-ui-accent,#eb008b); border-radius:20px; background:var(--smoof-ui-drag-bg,#fff); color:var(--smoof-ui-text,#19181c); font:600 18px/1.5 sans-serif; text-align:center; pointer-events:none; }
      [data-smoof-design-drop][hidden] { display:none; }
    `;
    document.head.appendChild(style);
    const hint = document.createElement('div');
    hint.dataset.smoofDesignDrop = '';
    hint.hidden = true;
    hint.setAttribute('role', 'status');
    document.body.appendChild(hint);
    let hideTimer;
    const hide = () => { clearTimeout(hideTimer); hint.hidden = true; };
    const zone = event => {
      if (!window.SmoofDesignModeContract?.inputFor?.('personalized')?.checked) return null;
      const node = event.target?.closest?.('.po-livePreview-root, [data-smoof-ui-commandbar], [data-smoof-ui-context], [data-smoof-ui-layers]');
      return node?.getClientRects().length ? node : null;
    };
    const hasFiles = event => Array.from(event.dataTransfer?.types || []).includes('Files');
    document.addEventListener('dragover', event => {
      const target = zone(event);
      if (!target || !hasFiles(event)) { hide(); return; }
      event.preventDefault();
      event.dataTransfer.dropEffect = fileBusy || nameDialogPending || fileReadPending ? 'none' : 'copy';
      if (fileBusy || nameDialogPending || fileReadPending) { hide(); return; }
      const bounds = target.getBoundingClientRect();
      hint.textContent = t('Eine .smoofdesign-Datei hier ablegen', 'Drop one .smoofdesign file here');
      Object.assign(hint.style, { left: bounds.left + 'px', top: bounds.top + 'px', width: bounds.width + 'px', height: bounds.height + 'px' });
      hint.hidden = false;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 1000);
    }, true);
    document.addEventListener('dragleave', event => { if (!event.relatedTarget) hide(); }, true);
    window.addEventListener('blur', hide);
    document.addEventListener('dragend', hide, true);
    document.addEventListener('drop', async event => {
      hide();
      if (!zone(event) || !hasFiles(event)) return;
      // Only editor file drops are consumed; object/text drags and outside uploads retain their handlers.
      event.preventDefault();
      event.stopImmediatePropagation();
      const files = Array.from(event.dataTransfer.files || []);
      if (files.length !== 1 || !/\.smoofdesign$/i.test(files[0].name)) {
        showStatus(t('Bitte legen Sie genau eine .smoofdesign-Datei ab.', 'Please drop exactly one .smoofdesign file.'), true);
        return;
      }
      try { await readFile(files[0]); }
      catch (error) { showStatus(error.message || t('Die Datei konnte nicht geöffnet werden.', 'The file could not be opened.'), true); }
    }, true);
  }

  window.SmoofDesignFileTools = Object.freeze({
    format: FORMAT,
    version: VERSION,
    supportsTemplateRestore: true,
    supportsDoubleSidedFiles: true,
    validate,
    save,
    exportPayload: () => fileOperation(() => saveFile({ download: false })),
    open,
    readFile,
    restore,
    capture: () => cleanForJson(captureSnapshot())
  });
  ensurePicker();
  installFileInteractions();
})();
